import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { CallLangMenuList } from '../components/CallLangMenuList';
import { ICallLangMenuListEvents, ICallLangMenuListFields } from '../components/types';
import { CallLangMenuListEvents } from './events';
import { getAuthUserLangCode } from '../../../../store/general/selectors';
import { ICallLangMenuListHOCProps } from './types';
import { getCallLangOptions } from '../../selectors/getCallLangOptions';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): ICallLangMenuListFields => {
		return {
			langCode: getAuthUserLangCode(state),
			options: getCallLangOptions(state),
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
	props: ICallLangMenuListHOCProps,
): ICallLangMenuListEvents => {
	const { onClose, onSaving } = props;
	return {
		onChange: (langCode) => onSaving(dispatch(CallLangMenuListEvents.onChange(langCode))),
		onClose,
	}
};

export const CallLangMenuListHOC = connect(
	mapStateToProps,
	mapDispatchToProps,
)(CallLangMenuList);

CallLangMenuListHOC.displayName = 'CallLangMenuListHOC';
